import axios from '../../../../utils/axios';
import { Badge, Button, Checkbox, Group, Table, Tabs } from '@mantine/core';
import { useEffect, useState } from 'react';

export default function UserManagement() {
  const [users, setUsers] = useState([]);
  useEffect(() => {
      axios.get("/users/all").then(function(res){
          if(res.status === 200){
              setUsers(res.data.data)
          }
      }).catch(function(err){
          console.log(err);
      });
  }, [])
  return (
    <Tabs defaultValue="users" color='green'>
      <Tabs.List>
        <Tabs.Tab value="users">Registered Users</Tabs.Tab>
        <Tabs.Tab value="admins">Admins</Tabs.Tab>
        <Tabs.Tab value="superAdmins">Super Admins</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="users" pt="xs">
        <Table striped highlightOnHover fontSize={"xs"} verticalSpacing="xs" horizontalSpacing="xs" style={{width: "100%"}}>
            <thead>
                <tr>
                  <tr>#</tr>
                <th>Full Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Joined</th>
                <th>Last Updated</th>
                <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {users.filter((itm2: any) => (itm2?.role.toLowerCase() !== "admin")).map((itm: any, idx: number) => {
                  return (
                  <tr key={idx}>
                    <td>
                      <Checkbox />
                    </td>
                    <td>{itm?.name}</td>
                     <td>{itm?.username}</td>
                     <td><Badge>User</Badge> </td>
                     <td>{new Date(itm.createdAt).toDateString()}</td>
                      <td>{new Date(itm.updatedAt).toDateString()}</td>
                     <td>
                      <Group noWrap>
                        <Button size='xs'>Edit</Button>
                        <Button size="xs" color="red">Delete</Button>
                      </Group>
                     </td>
                </tr>
                  )
                })}
                </tbody>
        </Table>
      </Tabs.Panel>

      <Tabs.Panel value="admins" pt="xs">
      <Table striped highlightOnHover fontSize={"xs"} verticalSpacing="xs" horizontalSpacing="xs" style={{width: "100%"}}>
            <thead>
                                <tr>
                  <tr>#</tr>
                <th>Full Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Joined</th>
                <th>Last Updated</th>
                <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {users.filter((itm2: any) => (itm2?.role.toLowerCase() === "admin")).map((itm: any, idx: number) => {
                  return (
                  <tr key={idx}>
                    <td>
                      <Checkbox />
                    </td>
                    <td>{itm?.name}</td>
                     <td>{itm?.username}</td>
                     <td><Badge>Admin</Badge> </td>
                     <td>{new Date(itm.createdAt).toDateString()}</td>
                      <td>{new Date(itm.updatedAt).toDateString()}</td>
                     <td>
                      <Group noWrap>
                        <Button size='xs'>Edit</Button>
                        <Button size="xs" color="red">Delete</Button>
                      </Group>
                     </td>
                </tr>
                  )
                })}
                </tbody>
        </Table>
      </Tabs.Panel>

      <Tabs.Panel value="superAdmins" pt="xs">
      <Table striped highlightOnHover fontSize={"xs"} verticalSpacing="xs" horizontalSpacing="xs" style={{width: "100%"}}>
            <thead>
                <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Role</th>
                <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>David</td>
                     <td>Kitavi</td>
                     <td>daviskitavi98@gmail.com</td>
                     <td>+254741582811</td>
                     <td><Badge>SuperAdmin</Badge></td>
                     <td>
                        <Group>
                            <Button variant="subtle" color="green" size="xs">Edit</Button>
                            <Button variant="subtle" color="red" size="xs">Delete</Button>
                        </Group>
                     </td>
                </tr>

                <tr>
                    <td>Edwin</td>
                     <td>Muriithi</td>
                     <td>kabuimuriithi@gmail.com</td>
                     <td>+254715204181</td>
                     <td><Badge>SuperAdmin</Badge></td>
                     <td>
                        <Group>
                            <Button variant="subtle" color="green" size="xs">Edit</Button>
                            <Button variant="subtle" color="red" size="xs">Delete</Button>
                        </Group>
                     </td>
                </tr>
                </tbody>
        </Table>
      </Tabs.Panel>


    </Tabs>
  );
}